import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { Link, useHistory, useLocation } from "react-router-dom";
// import { MobileView } from "react-device-detect";
import AuthModal from "../components/modals/Authentication";
import { SearchBar } from "../components/SearchBar";
import DropdownN from "../components/DropdownN";
import Dropdown from "../components/Dropdown";
import Button from "../components/Button";
import Modal from "../components/Modal";
import { SmallAvatar } from "../components/Avatar";
import LanguageSelector from "../components/LanguageSelector";
import useTranslation from "../hooks/useTranslation";
import ENV_CONFIG from "../config/environment-unified";

import { toast } from "react-toastify";
import axios from "axios";
import { bindActionCreators } from "redux";
import { useDispatch } from "react-redux";
import { actionCreators } from "../state/index";

// Import Icons
import accountIcon from "../img/icons/usergray.svg";
import settings from "../img/icons/settingsgray.svg";
import logoutIcon from "../img/icons/logout.svg";
import { ReactComponent as CollapseIcon } from "../img/icons/collapse.svg";
import { ReactComponent as BillIcon } from "../img/icons/bill.svg";
import BrandLogo from "../components/BrandLogo";
import { ReactComponent as MoonIcon } from "../img/icons/moon.svg";
import { ReactComponent as SunIcon } from "../img/icons/sun.svg";
import { ReactComponent as DollarIcon } from "../img/icons/dollar.svg";
// import { ReactComponent as InboxIcon } from "../img/icons/inbox.svg";
// import FrenchFlagIcon from "../img/icons/french-flag.png";
import GCoinIcon from "../img/icons/gcoin.png";

const Navbar = (props) => {
  const isLoggedIn = useSelector((state) => state.user.isLoggedIn);
  const pageName = window.location.pathname.split("/")[1];
  const pages = [
    "reset-password",
    "privacy-policy",
    "terms-and-conditions",
    "new-password",
    "how-to-stream",
  ];

  return (
    <NavbarStyle>
      <Link to="/" data-tour="header-logo">
        <BrandLogo />
      </Link>
      {pages.includes(pageName) ?
        <Link style={{ display: "block" }} to="/" data-tour="header-logo">
          <BrandLogo />
        </Link>
        :
        <SidebarCollapse toggleSidebar={props.toggleSidebar} data-tour="header-sidebar-toggle" />
      }

      <SearchBarWrapper data-tour="header-search">
        <SearchBar />
      </SearchBarWrapper>
      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
        {isLoggedIn && <GCoinsSoldWidget />}
        <div data-tour="header-theme" style={{ display: "flex", alignItems: "center" }}>
          <DarkModeSwitcher
            mode={props.theme.mode}
            changeTheme={props.changeTheme}
          />
        </div>
        <div data-tour="header-language" style={{ display: "flex", alignItems: "center" }}>
          <LanguageSelector />
        </div>
        <div data-tour="header-account" style={{ display: "flex", alignItems: "center" }}>
          {isLoggedIn ? (
            <User changemode={props.changeTheme} mode={props.theme.mode} />
          ) : (
            <Guest />
          )}
        </div>
      </div>
    </NavbarStyle>
  );
};
export default Navbar;

// Sub-Components
const GCoinsSoldWidget = () => {
  const { t } = useTranslation();
  const userData = useSelector((state) => state.user?.data);
  const [balance, setBalance] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBalance = async () => {
      if (!userData?.id) {
        setLoading(false);
        return;
      }
      
      try {
        const response = await axios.get(`${ENV_CONFIG.WALLET_BALANCE_ENDPOINT}/${userData.id}`, {
          timeout: 5000,
          withCredentials: true
        });

        if (response.data) {
          setBalance(response.data.balance || 0);
        }
      } catch (error) {
        console.error('❌ Error fetching balance:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchBalance();
    // Refresh every 30 seconds
    const interval = setInterval(fetchBalance, 30 * 1000);
    
    return () => clearInterval(interval);
  }, [userData]);

  const formatNumber = (num) => {
    if (num >= 1000000) {
      return `${(num / 1000000).toFixed(1)}M`;
    } else if (num >= 1000) {
      return `${(num / 1000).toFixed(1)}K`;
    }
    return num.toLocaleString();
  };

  if (loading) {
    return null;
  }

  return (
    <Link to="/gcoin-transactions" style={{ textDecoration: 'none' }}>
      <GCoinsSoldContainer title={`${balance.toLocaleString()} G-Coins - ${t('nav.clickToViewTransactions', 'Cliquez pour voir les transactions')}`}>
        <GCoinsIconImg src={GCoinIcon} alt="G-Coin" />
        <GCoinsText>
          {formatNumber(balance)} G-Coins
        </GCoinsText>
      </GCoinsSoldContainer>
    </Link>
  );
};

const DarkModeSwitcher = (props) => (
  <DarkModeSwitcherStyle
    mode={props.mode}
    icon
    nofocus="true"
    style={{ marginRight: "10px" }}
    onClick={props.changeTheme}
  >
    {props.mode === "dark" ? <SunIcon /> : <MoonIcon />}
  </DarkModeSwitcherStyle>
);
const Guest = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const query = new URLSearchParams(location.search || "");
  const noAuth = query.has("noAuth");

  const [authModal, setAuthModal] = useState(noAuth);
  const [tabIndex, setTabIndex] = useState(noAuth ? 1 : 2);

  // If we get redirected client-side to `/?noAuth`, open the login modal.
  useEffect(() => {
    if (!noAuth) return;
    setAuthModal(true);
    setTabIndex(1);
  }, [noAuth]);

  // Allow any page to open the existing auth modal (popup) without navigating.
  // Usage:
  // window.dispatchEvent(new CustomEvent("corearena:auth:open", { detail: { tabIndex: 1 } }))
  useEffect(() => {
    const handler = (e) => {
      const nextTabIndex = Number(e?.detail?.tabIndex) || 1; // 1=login, 2=signup
      setAuthModal(true);
      setTabIndex(nextTabIndex);
    };
    window.addEventListener("corearena:auth:open", handler);
    return () => window.removeEventListener("corearena:auth:open", handler);
  }, []);

  function hideModal() {
    setAuthModal(false);
  }
  function showModal(tabIndex) {
    // console.log("👉 showModal called with tabIndex =", tabIndex);

    setAuthModal(true);
    setTabIndex(tabIndex);
  }
  return (
    <>
      <Button
        size="small"
        onClick={() => showModal(1)}
        style={{ marginRight: "10px" }}
      >
        {t('auth.login', 'Login')}
      </Button>
      <Button size="small" variant="primary" onClick={() => showModal(2)}>
        {t('auth.signup', 'Sign Up')}
      </Button>
      <Modal
        isOpen={authModal}
        onRequestClose={hideModal}
        hideModal={hideModal}
      >
        <AuthModal tabIndex={tabIndex} hideModal={hideModal} />
      </Modal>
    </>
  );
};
const User = (props) => {
  const { t } = useTranslation();
  const userData = useSelector((state) => state.user?.data);
  const AvatarImg = userData?.avatar;
  const username = userData?.username;

  // Debug logs
  // console.log('🔍 [NAVBAR] User data:', userData);
  // console.log('🔍 [NAVBAR] Avatar:', AvatarImg);
  // console.log('🔍 [NAVBAR] Username:', username);

  const [showAvatarDrop, setShowAvatarDrop] = useState(false);
  const dispatch = useDispatch();
  const { logout } = bindActionCreators(actionCreators, dispatch);

  const useLogout = () => {
    // console.log('🚪 [NAVBAR] Logout initiated');
    axios
      .get(process.env.REACT_APP_LOGOUT_ENDPOINT, { withCredentials: true })
      .then((res) => {
        // console.log('✅ [NAVBAR] Logout successful');
        if (res.status === 200) {
          logout();
          document.cookie =
            "username=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
          window.location.reload();
        }
      })
      .catch((error) => {
        // console.log('❌ [NAVBAR] Logout error:', error);
        if (error?.response?.status === 401) logout();
        else if (error.response) {
          if (error?.response?.status === 500)
            toast.error("Internal server error.");
        } else if (error.request)
          toast.error("We are experiencing service outages.");
        else
          toast.error("Something is blocking you from accessing our servers.");
      });
  };

  const Avataroptions = [
    {
      type: 0,
      title: t('nav.profile', 'Profile'),
      icon: accountIcon,
      link: "/profile",
    },
    {
      type: 0,
      title: t('nav.settings', 'Settings'),
      icon: settings,
      link: "/settings",
    },
    {
      type: 2,
      title: t('auth.logout', 'Logout'),
      icon: logoutIcon,
      func: useLogout,
    },
  ];

  function handleAvatar() {
    setShowAvatarDrop(true);
  }

  return (
    <>
      {/* Buy G-Coins Button */}
      <Link to="/gcoin-store">
        <BuyGCoinsButton
          size="small"
          variant="primary"
          title={t('nav.buyGCoins', 'Buy G-Coins')}
        >
          <DollarIcon style={{ width: "16px", height: "16px", marginRight: "6px" }} />
          {t('nav.buyGCoins', 'Buy G-Coins')}
        </BuyGCoinsButton>
      </Link>

      <Notification />
      {/* <Button notification={true} icon>
        <InboxIcon />
      </Button> */}

      <div onClick={handleAvatar} style={{ position: "relative" }}>
        {showAvatarDrop && (
          <Dropdown
            show={showAvatarDrop}
            setShow={() => {
              setShowAvatarDrop(!showAvatarDrop);
            }}
            style={{ top: "100%" }}
            options={Avataroptions}
            margin="10px"
            width="130px"
          />
        )}
        <Button
          nofocus="true"
          icon
          style={{ padding: "0", marginLeft: "10px", position: "relative" }}
        >
          <SmallAvatar
            src={AvatarImg && !String(AvatarImg).startsWith('blob:') ? AvatarImg : undefined}
            alt={username || "User"}
            name={username || "User"}
          />
        </Button>
      </div>
    </>
  );
};
const Notification = () => {
  const isLoggedIn = useSelector((state) => state.user.isLoggedIn);
  const history = useHistory();
  const [newNotification, setNewNotification] = useState(false);
  const [showNotif, setShowNotif] = useState(false);
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchInvitations = async () => {
    if (!isLoggedIn) {
      setOptions([]);
      setNewNotification(false);
      return;
    }

    try {
      setLoading(true);
      const res = await axios.get(`${ENV_CONFIG.EVENTS_ENDPOINT}/events/my-invitations`, {
        withCredentials: true,
      });

      const invitations = res?.data?.invitations || [];
      const tournamentInvites = invitations.filter((inv) => inv?.event?.category?.slug === "tournament");
      const pending = tournamentInvites.filter((inv) => inv?.status === "inactive");

      // Badge = pending invitations
      setNewNotification(pending.length > 0);

      const mapped = tournamentInvites.map((inv) => {
        const ev = inv?.event || {};
        const isPending = inv?.status === "inactive";
        const status = String(inv?.status || "").toLowerCase();
        const statusLabel =
          status === "inactive" ? "Pending" : status === "active" ? "Accepted" : status === "removed" ? "Declined" : "—";
        const statusVariant =
          status === "inactive" ? "pending" : status === "active" ? "accepted" : status === "removed" ? "declined" : "neutral";
        const organizerUsername =
          ev?.organizer?.username ||
          (ev?.createdBy ? `user#${ev.createdBy}` : "");
        return {
          // Prefer tournament icon over placeholder "girl" image
          emoji: ev?.category?.icon || "🏆",
          // Keep an image fallback if you ever want to use it (e.g., organizer avatar)
          profileImg: ev?.organizer?.avatar || ev?.bannerImage || ev?.coverImage || null,
          fullName: ev?.name || "Tournament",
          notRead: isPending,
          badgeText: statusLabel,
          badgeVariant: statusVariant,
          data: organizerUsername
            ? `by @${organizerUsername}`
            : (isPending ? "Tournament invitation" : "Invitation accepted"),
          _invitation: inv,
        };
      });

      setOptions(mapped);
    } catch (e) {
      // Fail closed (no badge / no list) rather than spamming toasts
      console.error("❌ Failed to fetch invitations for navbar notification:", e);
      setOptions([]);
      setNewNotification(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchInvitations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn]);

  const handleNotification = async () => {
    setShowNotif((v) => !v);
    // Fetch fresh data when opening
    if (!showNotif) {
      await fetchInvitations();
    }
  };

  return (
    <div onClick={handleNotification} style={{ position: "relative" }}>
      <Button
        icon
        style={{ marginRight: "10px", position: "relative" }}
        notification={newNotification}
      >
        {showNotif && (
          <DropdownN
            show={showNotif}
            setShow={() => {
              setShowNotif(!showNotif);
            }}
            style={{ top: "100%" }}
            title={loading ? "Loading..." : "Invitations"}
            options={options}
            onItemClick={() => {
              history.push("/my-events?tab=invitations");
            }}
            onMarkAllRead={() => {
              history.push("/my-events?tab=invitations");
              setShowNotif(false);
            }}
          />
        )}
        <BillIcon />
      </Button>
    </div>
  );
};
const SidebarCollapse = (props) => {
  return (
    <SidebarCollapseStyle
      icon
      nofocus="true"
      size="small"
      onClick={props.toggleSidebar}
    >
      <CollapseIcon />
    </SidebarCollapseStyle>
  );
};

// Styling
const DarkModeSwitcherStyle = styled(Button)`
  svg {
    max-width: 20px;
    max-height: 20px;
    width: 20px;
  }
  ${({ mode, theme }) =>
    mode === "light" &&
    `
    svg path{
      fill: ${theme.color.darkerText} !important;
    `}
  ${({ mode }) =>
    mode === "dark" &&
    `
  svg path {
      :nth-child(1) {
        fill: #ffcc33;
        opacity: 1;
      }
      :nth-child(2) {
        fill: #fc9601;
      }
  }
  `}
`;
const SearchBarWrapper = styled.div`
  width: 50%;
  margin: auto;
`;
const NavbarStyle = styled.nav`
  border-bottom: 1px solid ${({ theme }) => theme.color.border};
  padding: 5px 3rem;
  height: clamp(50px, 50px, 50px);
  display: flex;
  justify-content: space-between;
  align-items: center;
  > a {
    display: none;
  }
  /* Keep icons theme-tinted, but don't override the brand logo fills */
  svg:not(.brand-logo) path {
    fill: ${({ theme }) => theme.color.primaryText};
  }
  @media only screen and (max-width: 576px) {
    padding: 5px 1.5rem;
    height: 70px;
    min-height: 70px;
    > a {
      display: inline-block;
    }
  }
`;
const SidebarCollapseStyle = styled(Button)`
  position: relative;
  right: 27px;
  @media only screen and (max-width: 1200px) {
    display: none !important;
  }
`;

const BuyGCoinsButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  margin-right: 10px;
  white-space: nowrap;
  
  svg {
    flex-shrink: 0;
  }

  svg path {
    fill: white;
  }

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  @media only screen and (max-width: 768px) {
    font-size: 12px;
    padding: 6px 10px;
    
    svg {
      width: 14px !important;
      height: 14px !important;
      margin-right: 4px !important;
    }
  }
`;

const GCoinsSoldContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  background: ${({ theme }) => theme.color.backgroundLighter};
  border: 1px solid ${({ theme }) => theme.color.border};
  border-radius: 8px;
  padding: 6px 12px;
  margin-right: 10px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: ${({ theme }) => theme.color.backgroundLight};
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
    border-color: #667eea;
  }

  @media only screen and (max-width: 768px) {
    padding: 4px 8px;
    gap: 4px;
  }

  @media only screen and (max-width: 576px) {
    display: none;
  }
`;

const GCoinsIconImg = styled.img`
  width: 22px;
  height: 22px;
  object-fit: contain;
  
  @media only screen and (max-width: 768px) {
    width: 18px;
    height: 18px;
  }
`;

const GCoinsText = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: ${({ theme }) => theme.color.primaryText};
  white-space: nowrap;
  
  @media only screen and (max-width: 768px) {
    font-size: 11px;
  }
`;
